import React from "react";
import { CheckCircle } from 'lucide-react';
import { NavItem } from "../NavItem";

export function ValidateLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/validate"
            Icon={CheckCircle}
            label="Validate"
            isCollapsed={isCollapsed}
        />
    );
}
